import React from 'react';
import {
  Box,
  Typography,
  Link
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 2,
        backgroundColor: theme.palette.mode === 'dark'
          ? theme.palette.grey[900]
          : theme.palette.grey[50],
        borderTop: `1px solid ${theme.palette.divider}`,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        zIndex: 1000
      }}
    >
      <Box sx={{ textAlign: 'left' }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontSize: '0.65rem', // Very small font
            fontWeight: 400,
            lineHeight: 1.3
          }}
        >
          © 2025 Redis Ltd. All rights reserved. If you have any issues / suggestions please{' '}
          <Link
            href="mailto:etti.biton@redis.com"
            sx={{
              color: theme.palette.primary.main,
              textDecoration: 'none',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                textDecoration: 'underline',
                color: theme.palette.primary.dark
              },
              '&:focus': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: '2px',
                borderRadius: '2px'
              }
            }}
            aria-label="Send email to etti.biton@redis.com for issues or suggestions"
          >
            contact us
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
